var ConfirmDialog_1;
import { __decorate } from "tslib";
import Vue from 'vue';
import Component from "vue-class-component";
let ConfirmDialog = ConfirmDialog_1 = class ConfirmDialog extends Vue {
    dialog = false;
    working = false;
    hold = false;
    title = '';
    text = '';
    cancel = '';
    confirm = '';
    maxWidth = 350;
    confirmDialog(value) {
        document.dispatchEvent(new CustomEvent('closeConfirmDialog', {
            detail: { confirmed: value },
        }));
        // run() keeps the dialog up, so the spinner is what the user watches
        // while the action it confirmed is still talking to the backend.
        if (value && this.hold) {
            this.working = true;
            return;
        }
        this.dialog = false;
    }
    finishConfirmDialog() {
        this.working = false;
        this.dialog = false;
    }
    openConfirmDialog(e) {
        this.title = e.detail.title;
        this.text = e.detail.text;
        this.cancel = e.detail.cancel;
        this.confirm = e.detail.confirm;
        this.maxWidth = e.detail.maxWidth;
        this.hold = e.detail.hold === true;
        this.working = false;
        this.dialog = true;
    }
    static async open(title = 'Potvrzení', text = 'Opravdu?', confirm = 'Ano', cancel = 'Ne', maxWidth = 350, hold = false) {
        document.dispatchEvent(new CustomEvent('openConfirmDialog', {
            detail: { title, text, confirm, cancel, maxWidth, hold },
        }));
        let confirmed = false;
        let resolveFunction = () => { };
        const resolveDialog = (e) => {
            confirmed = e.detail.confirmed;
            resolveFunction();
        };
        await new Promise(resolve => {
            resolveFunction = resolve;
            document.addEventListener('closeConfirmDialog', resolveDialog);
        });
        document.removeEventListener('closeConfirmDialog', resolveDialog);
        return confirmed;
    }
    /**
     * Confirm, then run the action while the dialog stays up with a spinner.
     * Without it the dialog closes on confirm and a slow backend call happens
     * with nothing on screen to show the app is working.
     */
    static async run(action, title = 'Potvrzení', text = 'Opravdu?', confirm = 'Ano', cancel = 'Ne', maxWidth = 350) {
        if (!await ConfirmDialog_1.open(title, text, confirm, cancel, maxWidth, true)) {
            return undefined;
        }
        try {
            return await action();
        }
        finally {
            document.dispatchEvent(new CustomEvent('finishConfirmDialog'));
        }
    }
    created() {
        document.addEventListener('openConfirmDialog', this.openConfirmDialog);
        document.addEventListener('finishConfirmDialog', this.finishConfirmDialog);
    }
    beforeDestroy() {
        document.removeEventListener('openConfirmDialog', this.openConfirmDialog);
        document.removeEventListener('finishConfirmDialog', this.finishConfirmDialog);
    }
};
ConfirmDialog = ConfirmDialog_1 = __decorate([
    Component
], ConfirmDialog);
export default ConfirmDialog;
